import '.cf{font-size:1.125rem;}.ssr-plugin'
import '.fi{line-height:1.75rem;}.ssr-plugin'
import '.cd{text-decoration:none;}.ssr-plugin'
import '.e5{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cf fi"
    >
      {translations.privacySubtitle}{' '}
      <a className="cd e5"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="cd e5"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
